import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-play-fill text-background-50 text-sm"></i>
            </div>
            <span className="text-xl font-bold text-foreground-900 font-heading tracking-tight">
              蓝莓视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/dianshiju"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname.startsWith('/category')
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              分类
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索视频..."
                className="w-48 pl-9 pr-4 py-2 text-sm rounded-full border border-background-300 bg-background-100 text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-all"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 cursor-pointer"
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl text-foreground-700 ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4 animate-in slide-in-from-top-2">
          <div className="flex flex-col gap-3">
            <Link to="/" className="px-4 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 cursor-pointer">首页</Link>
            <Link to="/category/dianshiju" className="px-4 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 cursor-pointer">分类浏览</Link>
            <Link to="/about" className="px-4 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 cursor-pointer">关于我们</Link>
            <div className="relative mt-2">
              <input
                type="text"
                placeholder="搜索视频..."
                className="w-full pl-9 pr-4 py-2.5 text-sm rounded-lg border border-background-300 bg-background-100 text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}